/**
 * A custom directive to filter the pin input as it's typed with a valid
 * numeric pin.
 *
 */
App.directive('ngPinFilter', ['$rootScope', function($rootScope) {
    var validateTimeout = null;
    var endValidationTimeout = null;

    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ngModel) {
            if (!ngModel) {
            	void 0;
                return;
            }

            $rootScope.$watch('formData.pin', function (val) {
            	if(val)
            	{
            		$rootScope.formData.pin = val.toString().replace(/[^0-9]/g,"");
            	}
            });
        }
    }
}]);